// extracted by mini-css-extract-plugin
module.exports = {"ContainerPartnerButton":"styles_ContainerPartnerButton__xrRVs","PartnerButton":"styles_PartnerButton__3ahDs"};